import { observer } from 'mobx-react';
import { TextConstants } from '../../TextConstants';
import CollapsibleCard from '../../../App/Components/CollapsibleCard';
import React from 'react';
import RunInterceptionComponentVM from './RunInterceptionComponentVM';
import { Neo } from '@singularsystems/neo-react';
import { ValidationDisplayMode } from '@singularsystems/neo-core/dist/Validation/Misc';
import { EnumHelper } from '@singularsystems/neo-core';
import { RunProcessComponentDropDownItems } from './RunProcessComponentDropDownEnum';

interface IRunInterceptionComponentProps {
    viewModel: RunInterceptionComponentVM;
    interceptionStoredProcedure: string;
}

@observer
export default class RunInterceptionComponent extends React.Component<IRunInterceptionComponentProps> {
    public render() {
        var viewModel = this.props.viewModel;

        return (
            <>
                <CollapsibleCard
                    title={TextConstants.Titles.RunProcesses}
                    isExpanded={false}>
                    <>
                        <Neo.Form
                            validationDisplayMode={ValidationDisplayMode.AfterSubmit}
                            model={viewModel.scheduleProcessCommand}
                            onSubmit={() => viewModel.runProcess(this.props.interceptionStoredProcedure)}>
                            <div className="row">
                                <div className="col-lg-2 col-md-2 pb-3">
                                    <Neo.DropDown
                                        bind={viewModel.scheduleProcessCommand.meta.processToBeRun}
                                        select={{ items: EnumHelper.asList(RunProcessComponentDropDownItems), deSelectText: "Please select an option" }}
                                        onClick={() => viewModel.setProcess()}>
                                    </Neo.DropDown>
                                </div>
                                {viewModel.scheduleProcessCommand.meta.processToBeRun.value !== "" &&
                                    <div className="col-lg-2 col-md-2">
                                        <Neo.Button size="sm" isSubmit>
                                            {TextConstants.Buttons.RunProcess}
                                        </Neo.Button>
                                    </div>
                                }
                            </div>
                            <div className="row">
                                {viewModel.runInterception &&
                                    <div className="col-lg-2 col-md-2">
                                        <Neo.FormGroup
                                            bindContext={viewModel.scheduleProcessCommand.meta.serviceProviderName}
                                            label={TextConstants.Labels.ServiceProvider}>
                                            <Neo.AutoCompleteDropDown
                                                itemSource={viewModel.serviceProviderApiClient.getServiceProviderListByCriteria}
                                                bind={viewModel.scheduleProcessCommand.meta.staticServiceProviderID}
                                                bindDisplay={viewModel.scheduleProcessCommand.meta.serviceProviderName}
                                                displayMember={"serviceProviderName"}
                                                items={viewModel.serviceProviderApiClient.getServiceProviderListByCriteria(" ").then((arr) => arr.data.slice(0,10)
                                                    .sort((x, y) => x.serviceProviderName.localeCompare(y.serviceProviderName))
                                                )}
                                            />
                                        </Neo.FormGroup>
                                    </div>
                                }
                                {viewModel.runBookCostCalc &&
                                    <>
                                        <div className="col-lg-2 col-md-2">
                                            <Neo.FormGroup
                                                bindContext={viewModel.scheduleProcessCommand.meta.serviceProviderGroupingName}
                                                label={TextConstants.Labels.Broker}>
                                                <Neo.AutoCompleteDropDown
                                                    itemSource={viewModel.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria}
                                                    bind={viewModel.scheduleProcessCommand.meta.staticServiceProviderFileGroupingID}
                                                    bindDisplay={viewModel.scheduleProcessCommand.meta.serviceProviderGroupingName}
                                                    displayMember={"serviceProviderGroupingName"}
                                                    items={viewModel.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria(" ").then((arr) => arr.data
                                                        .sort((x, y) => x.serviceProviderGroupingName.localeCompare(y.serviceProviderGroupingName))
                                                    )}
                                                />
                                            </Neo.FormGroup>
                                        </div>
                                        <div className="col-lg-2 col-md-2">
                                            <Neo.FormGroup
                                                bindContext={viewModel.scheduleProcessCommand.meta.clientAccountId}
                                                label={TextConstants.Labels.ClientAccount}>
                                                <Neo.AutoCompleteDropDown
                                                    isReadOnly={viewModel.scheduleProcessCommand.meta.staticServiceProviderFileGroupingID.value === 0}
                                                    itemSource={(searchValue: string) => viewModel.clientAccountApiClient.getClientAccountNumbersListByCriteria(searchValue, viewModel.scheduleProcessCommand.meta.staticServiceProviderFileGroupingID.value!)}
                                                    bind={viewModel.scheduleProcessCommand.meta.clientAccountId}
                                                    bindDisplay={viewModel.scheduleProcessCommand.meta.clientAccountName}
                                                    displayMember={"serviceProviderAccountNumber"}
                                                />
                                            </Neo.FormGroup>
                                        </div>
                                        <div className="col-lg-2 col-md-2">
                                            <Neo.FormGroup
                                                label={TextConstants.Labels.Instrument}>
                                                <Neo.AutoCompleteDropDown
                                                    minCharacters={3}
                                                    delayMs={1500}
                                                    bind={viewModel.scheduleProcessCommand.meta.staticInstumentID}
                                                    bindDisplay={viewModel.scheduleProcessCommand.meta.staticInstrumentName}
                                                    descriptionMember={"isin"}
                                                    items={viewModel.filteredInstruments}
                                                    itemSource={async (searchText) => viewModel.instruments.filter(instrument => instrument.description?.toLowerCase().includes(searchText.toLowerCase()))}
                                                    >

                                                </Neo.AutoCompleteDropDown>
                                            </Neo.FormGroup>
                                        </div>

                                        <div className="col-lg-2 col-md-2">
                                            <Neo.FormGroup
                                                appendText="fa-calendar"
                                                label={TextConstants.Labels.StartDate}
                                                bind={viewModel.scheduleProcessCommand.meta.startDateRange}
                                                dateProps={{ formatString: "dd MMM yyyy" }}
                                            />
                                        </div>
                                        <div className="col-lg-2 col-md-2">
                                            <Neo.FormGroup
                                                appendText="fa-calendar"
                                                label={TextConstants.Labels.EndDate}
                                                bind={viewModel.scheduleProcessCommand.meta.endDateRange}
                                                dateProps={{ formatString: TextConstants.DateFormats.dateMonthYear }}
                                            />
                                        </div>
                                    </>
                                }
                            </div>
                        </Neo.Form>
                    </>
                </CollapsibleCard>
            </>
        )
    }
}

